import { API, Auth } from 'aws-amplify';


export const query = /* GraphQL */ `
  mutation TriggerTestsExecutions($tests: [String], $brands: [Int]) {
    triggerTestsExecutions(tests: $tests, brands: $brands) {
      ... on TriggerTestsExecutionsSuccess {
        __typename
        result
      }
      ... on BadRequest {
        __typename
        message
        statusCode
      }
      ... on Forbidden {
        __typename
        message
        statusCode
      }
      ... on InternalServerError {
        __typename
        message
        statusCode
      }
      ... on NotFound {
        __typename
        message
        statusCode
      }
    }
}
`;

interface TriggerTestsExectuionsSuccess {
  __typename: 'TriggerTestsExecutionsSuccess';
  result: string;
}

interface ErrorResponse {
  __typename: 'BadRequest' | 'Forbidden' | 'InternalServerError' | 'NotFound';
  message: string;
  statusCode?: number;
}

type TriggerTestsExecutionsResponse = TriggerTestsExectuionsSuccess | ErrorResponse;

interface GraphQLResponse {
  data: {
    triggerTestsExecutions: TriggerTestsExecutionsResponse;
  };
}


   async function triggerTestsExecutionsService({ brands, tests }: { brands?: string[]; tests?: string[] }): Promise<string> {
    try {
      const user = await Auth.currentAuthenticatedUser();
      const postData = await API.graphql({
        query,
        variables: {
          brands,
          tests,
        },
        authToken: user.signInUserSession.accessToken.jwtToken,
      }) as GraphQLResponse;

      if (!postData.data) {
        return Promise.reject(new Error('Internal Server Error'));
      }

      const response = postData.data.triggerTestsExecutions;

      if (response.__typename === 'TriggerTestsExecutionsSuccess') {
        return response.result;
      }

      throw new Error(response.message);
    } catch (error: any) {
      console.error('Error in triggerHealthCalculationService:', error);
      throw new Error(`Internal Server Error: ${error.errors ? error.errors[0].message : error.message}`);
    }
}
  


export default triggerTestsExecutionsService;